export default {"src":"/_next/static/media/linkedin.8f8a733b.svg","height":35,"width":35};